import { Form, FormInstance, Input } from 'antd';

export interface PageFormProps {
  form: FormInstance;
  group?: string;
  onChange?: () => void;
}

// isActive: boolean;
// key: string;
// name: string;
// title: string;
// description: string;
// keywords: string;
// data: AnyObject;

export default function PageForm({ form, group, onChange }: PageFormProps): JSX.Element {
  return (
    <div style={{ maxWidth: 600 }}>
      <Form.Item
        label="Key/page"
        name={group ? [group, 'key'] : 'key'}
        rules={[{ required: true, message: 'Please enter page key/name' }, { max: 255 }]}
      >
        <Input placeholder="home-page" />
      </Form.Item>
      <Form.Item label="SEO title" name={group ? [group, 'title'] : 'title'} rules={[{ max: 255 }]}>
        <Input placeholder="Home page. Bla bla ..." />
      </Form.Item>
      <Form.Item label="Header" name={group ? [group, 'name'] : 'name'} rules={[{ max: 255 }]}>
        <Input placeholder="Home" />
      </Form.Item>
      <Form.Item label="Meta description" name={group ? [group, 'description'] : 'description'} rules={[{ max: 255 }]}>
        <Input.TextArea rows={3} placeholder="Description" />
      </Form.Item>
      <Form.Item
        label="Focus keywords (separate keywords with commas)"
        name={group ? [group, 'keywords'] : 'keywords'}
        rules={[{ max: 255 }]}
      >
        <Input placeholder="Keywords" />
      </Form.Item>
      <Form.Item label="Any data (json)" name={group ? [group, 'data'] : 'data'} rules={[{ max: 65000 }]}>
        <Input.TextArea rows={4} placeholder='{ "any": "data" }' />
      </Form.Item>
    </div>
  );
}
